import { put, post, get, del, postFd, putFd } from "@utils/axios";

const api = "case-management/";

// export const getCasesReq = () => {
//   return get(`${api}list-jobs`);
// }

export const getCasesReq = (payload) => {
  // payload: { type, page, limit }
  const { type = 'total', page = 1, limit = 10 } = payload || {};
  return get(`${api}list-jobs?page=${page}&limit=${limit}`);
};



export const getCaseDependenciesReq = () => {
  return get(`${api}jobs-dependencies`);
}

export const getClinicsDataReq = (id) => {
  return get(`${api}get-clinics`);
}

export const getEligibleOwnersReq = () => {
  return get(`${api}eligible-owners`);
}

// `excludeId` is the case being edited — a case cannot be a refinement
// of itself, and offering it its own row put it on hold instead.
export const getCompleteCaseDataReq = (excludeId) => {
  return get(`${api}get-complete-case${ excludeId ? `?exclude=${ excludeId }` : '' }`);
}

export const getCaseDataReq = (id) => {
  return get(`${api}get-case-data/${id}`);
}

export const createCaseReq = (payload) => {
  return postFd(`${api}jobs`, payload);
}

export const deleteCaseReq = (id) => {
  return del(`${api}jobs/${id}`);
}

export const updateCaseReq = (payload) => {
  return postFd(`${api}jobs/${payload.object.id}`, payload);
}

export const changeStatusReq = (payload) => {
  return post(`${api}-change`, payload);
}

export const requestStlcReq = (payload) => {
  return get(`${api}request-stlc/` + payload);
}

export const deleteCaseFileReq = (payload) => {
  return del(`${api}delete-case-file/${payload.id}/${payload.type}`);
}
